import useSWR from 'swr'
import { guardClient } from '../_axios'

export type ReportSummary = {
  sales: string
  achievementRate: string
  yearOnYear: string
  operationRate: string
}

export type SalesMetric = {
  label: string
  value: string
  note: string
  trend: string
}

export type MonthlyTrend = {
  month: string
  sales: string
  achievementRate: string
  meetings: string
  contractRate: string
}

type ReportsResponse = {
  data: {
    summary: ReportSummary
    metrics: SalesMetric[]
    monthly: MonthlyTrend[]
  }
}

const reportsFetcher = async (_urlTail: string): Promise<ReportsResponse> => {
  // const response = await guardClient.get<ReportsResponse>(_urlTail).then((r) => r.data)
  void guardClient

  return Promise.resolve({
    data: {
      summary: {
        sales: '¥156.8M',
        achievementRate: '87.1%',
        yearOnYear: '+22.5%',
        operationRate: '92.5%'
      },
      metrics: [
        {
          label: '年間売上',
          value: '¥156.8M',
          note: '目標: ¥180.0M',
          trend: '前年比 +22.5%'
        },
        {
          label: '粗利額（年間）',
          value: '¥54.9M',
          note: '粗利率: 35.0%',
          trend: '前年比 +19.8%'
        },
        {
          label: '平均単価（月額）',
          value: '¥612K',
          note: '目標: ¥600K',
          trend: '前月比 +¥18K'
        }
      ],
      monthly: [
        {
          month: '1月',
          sales: '¥14.2M',
          achievementRate: '94.7%',
          meetings: '48件',
          contractRate: '35.4%'
        },
        {
          month: '2月',
          sales: '¥12.4M',
          achievementRate: '82.7%',
          meetings: '47件',
          contractRate: '34.2%'
        }
      ]
    }
  })
}

export const useReports = () => {
  const path = '/company/reports'
  const { data, mutate } = useSWR(path, reportsFetcher, {
    onErrorRetry: () => {
      return
    }
  })

  return { data: data?.data, mutate }
}
